import { render, staticRenderFns } from "./CodePage.vue?vue&type=template&id=7bfa8f96&scoped=true&"
import script from "./CodePage.vue?vue&type=script&lang=js&"
export * from "./CodePage.vue?vue&type=script&lang=js&"
import style0 from "./CodePage.vue?vue&type=style&index=0&id=7bfa8f96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa8f96",
  null
  
)

export default component.exports